import UikAvatar from "./components/Universal/Avatar.vue"
import UikAvatarUpload from "./components/Universal/AvatarUpload.vue"
import UikButton from "./components/Universal/Button"
import UikButtonGroup from "./components/Universal/ButtonGroup"
import UikCheckbox from "./components/Universal/Checkbox"
import UikContentTitle from "./components/Universal/ContentTitle"
import UikContainer from "./components/Universal/Container"
import UikDivider from "./components/Universal/Divider"
import UikFormInputGroup from "./components/Universal/FormInputGroup"
import UikHeadline from "./components/Universal/Headline"
import UikHeadlineDesc from "./components/Universal/HeadlineDesc"
import UikInput from "./components/Universal/Input"
import UikNavLink from "./components/Universal/NavLink"
import UikNavSection from "./components/Universal/NavSection"
import UikNavSectionTitle from "./components/Universal/NavSectionTitle"
import UikNavTitle from "./components/Universal/NavTitle"
import UikProgressBar from "./components/Universal/ProgressBar"
import UikRadio from "./components/Universal/Radio"
import UikTabItem from "./components/Universal/TabItem"
import UikTabContainer from "./components/Universal/TabContainer"
import UikTabs from "./components/Universal/Tabs"
import UikTag from "./components/Universal/Tag"
import UikTagContainer from "./components/Universal/TagContainer"
import UikTopBar from "./components/Universal/TopBar"
import UikTopBarSection from "./components/Universal/TopBarSection"
import UikTopBarTitle from "./components/Universal/TopBarTitle"
import UikTopBarLink from "./components/Universal/TopBarLink"
import UikTopBarLinkContainer from "./components/Universal/TopBarLinkContainer"
import Uikon from "./components/Universal/Uikon"
import UikIcon from "./components/Universal/Icon"
import UikWidget from "./components/Universal/Widget"
import UikWidgetHeader from "./components/Universal/WidgetHeader"
import UikWidgetContent from "./components/Universal/WidgetContent"
import UikWidgetBottomCta from "./components/Universal/WidgetBottomCta"
import UikToggle from "./components/Universal/Toggle"
import UikDrawer from "./components/Universal/Drawer"
import UikPopup from "./components/Universal/Popup"
import UikPrompt from "./components/Universal/Prompt"
import UikOverlay from "./components/Universal/Overlay"
import UikSelect from "./components/Universal/Select"
import UikSlider from "./components/Universal/Slider"
import UikToggleText from "./components/Universal/ToggleText"
import UikSearch from "./components/Universal/Search"
import UikBreadcrumbs from "./components/Universal/Breadcrumbs"
import UikFiltersContainer from "./components/Universal/FiltersContainer"
import UikCta from "./components/Universal/Cta"
import UikDatePicker from "./components/Universal/DatePickerOne/DatePickerOne"
import UikDatepicker from "./components/Universal/Datepicker/Datepicker"
import UikDropdown from "./components/Universal/Dropdown"
import UikDropdownItem from "./components/Universal/DropdownItem"
import UikLoader from "./components/Universal/Loader"
import UikLoadingOverlay from "./components/Universal/LoadingOverlay"
import UikTooltip from "./components/Universal/Tooltip"
import UikUpload from "./components/Universal/Upload"
import UikCollapse from "./components/Universal/Collapse"
import TableComponents from "./components/Universal/Table/import.js"
import DataComponents from "./components/Universal/Data/import.js"

const components = [
    UikAvatar,
    UikAvatarUpload,
    UikButton,
    UikButtonGroup,
    UikCheckbox,
    UikContentTitle,
    UikContainer,
    UikDivider,
    UikToggle,
    UikFormInputGroup,
    UikHeadline,
    UikHeadlineDesc,
    UikInput,
    UikNavLink,
    UikNavSection,
    UikNavSectionTitle,
    UikNavTitle,
    Uikon,
    UikIcon,
    UikProgressBar,
    UikRadio,
    UikTabItem,
    UikTabContainer,
    UikTabs,
    UikTag,
    UikTagContainer,
    UikTopBar,
    UikTopBarSection,
    UikTopBarTitle,
    UikTopBarLink,
    UikTopBarLinkContainer,
    UikWidget,
    UikWidgetHeader,
    UikWidgetContent,
    UikWidgetBottomCta,
    UikDrawer,
    UikPopup,
    UikPrompt,
    UikOverlay,
    UikSelect,
    UikSlider,
    UikToggleText,
    UikSearch,
    UikBreadcrumbs,
    UikFiltersContainer,
    UikCta,
    UikDatePicker,
    UikDatepicker,
    UikDropdown,
    UikDropdownItem,
    UikLoader,
    UikLoadingOverlay,
    UikTooltip,
    UikUpload,
    UikCollapse,
    ...TableComponents,
    ...DataComponents
]

const install = function (Vue, opts = {}) {
    components.forEach(component => {
        Vue.component(component.name, component)
    })
    // UIK prompt method
    let PromptClass = Vue.extend(UikPrompt)
    Vue.$Uik = Vue.prototype.$Uik = {
        prompt: (props) => {
            return new Promise((resolve, reject) => {
                var params = { ...props, visible: false }
                let instance = new PromptClass({
                    propsData: params
                })
                instance.$mount()
                instance.visible = true
                instance.$on("close", payload => {
                    instance.visible = false
                    setTimeout(() => {
                        instance.$destroy()
                        document.querySelector("body").removeChild(prompt)
                    }, 500)
                    resolve({ action: "close", data: payload })
                })
                instance.$on("confirm", payload => {
                    instance.$destroy()
                    document.querySelector("body").removeChild(prompt)
                    resolve({ action: "confirm", data: payload })
                })
                let prompt = document.querySelector("body").appendChild(instance.$el)
            })
        },
        // If vueI18n is installed this will be overwriten
        // otherwise will return default string
        $t (path, value) {
            return value
        }
    }
    Vue.$uik = Vue.prototype.$uik = Vue.prototype.$Uik
}

/* istanbul ignore if */
if (typeof window !== "undefined" && window.Vue) {
    install(window.Vue)
}

export default {
    install,
    ...components
}
